import { render, staticRenderFns } from "./DoItOrderComponent.vue?vue&type=template&id=32a4a562&scoped=true&"
import script from "./DoItOrderComponent.vue?vue&type=script&lang=js&"
export * from "./DoItOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4a562",
  null
  
)

export default component.exports